import { Tooltip } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { Dialog } from '@progress/kendo-react-dialogs';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import * as React from 'react';
import { useEffect, useState } from 'react';
import failImg from '../../../../Assets/fail.png';
import successImg from '../../../../Assets/success.png';
import api from '../../../../libs/api';
import useStylesGrid from '../../../../styles/grid.styles';
import useStyles from '../../styles/useStyles';

export enum TypeOfXMLFile {
    Send = 0,
    Reponse = 1,
}

const CellWithButton = ({ action, data, handleDownloadDocument }: any) => {
    const classes = useStyles();
    const classesGrid = useStylesGrid();

    const icon =
        action == 'downloadSend' ? (
            <CloudDownloadIcon
                className={classes.baseFontAwesomeIcon + ' ' + classes.downloadButtonIcon}
                onClick={() => handleDownloadDocument(data, TypeOfXMLFile.Send)}
            />
        ) : (
            <CloudDownloadIcon
                className={classes.baseFontAwesomeIcon + ' ' + classes.downloadButtonIcon}
                onClick={() => handleDownloadDocument(data, TypeOfXMLFile.Reponse)}
            />
        );

    return (
        <td className={classesGrid.fileNameDocumentGridViewDocuments}>
            {action == 'downloadSend' ? data?.fileNameDocumentSend : data?.fileNameDocumentResponse}
            <span className={classes.verticalAlignItem}>
                {icon}
            </span>
        </td>
    );
};

const RelaticsDocumentsDialog = ({
    handleDownloadDocument,
    documentsDialogActive,
    setDocumentsDialogActive,
    currentSelectedItem,
}: any) => {
    const classes = useStyles();

    const classesGrid = useStylesGrid();
    const [documentsForModal, setDocumentsForModal] = useState();
    useEffect(() => {
        api.get('/api/v2/AsiteRelaticsSync/GetInfoDocumentsForRelaticsSyncLogItem', {
            safe: true,
            params: { RelaticsDocumentsSyncLogId: currentSelectedItem.id },
        })
            .then((res: any) => {
                const documentsWithDateObject = res.map((item: any) => {
                    return {
                        ...item,
                        startDate: new Date(item.startDate),
                        endDate: new Date(item.endDate),
                    };
                });
                setDocumentsForModal(documentsWithDateObject);
            })
            .catch((err) => console.log(err));
    }, [currentSelectedItem]);

    return (
        <div>
            {documentsDialogActive && (
                <Dialog
                    title={'Documents view'}
                    onClose={() => {
                        setDocumentsDialogActive(!documentsDialogActive);
                    }}
                    autoFocus={true}
                >
                    <Grid
                        style={{ display: 'flex', flexDirection: 'column', maxHeight: '80vh' }}
                        data={documentsForModal}
                    >
                        <GridColumn
                            field={'startDate'}
                            title="Start Date"
                            format="{0:dd/MM/yyyy HH:mm:ss}"
                            filterable={false}
                            headerClassName={classesGrid.gridColumnHeader}
                            className={classesGrid.gridColumn}
                            width={'150'}
                        />
                        <GridColumn
                            field={'endDate'}
                            title="End Date"
                            format="{0:dd/MM/yyyy HH:mm:ss}"
                            filterable={false}
                            headerClassName={classesGrid.gridColumnHeader}
                            className={classesGrid.gridColumn}
                            width={'150'}
                        />
                        <GridColumn
                            field={'error'}
                            title="Status"
                            filterable={false}
                            headerClassName={classesGrid.gridColumnHeader}
                            className={classesGrid.gridColumn}
                            cell={(props: any) => (
                                <td {...props} style={{ textAlignLast: 'center' }}>
                                   { <Tooltip title={!props.dataItem.error ? 'Error' : 'Sucess'}>
                                        <span>
                                            <img
                                                className={classes.verticalAlignItem}
                                                width={'20px'}
                                                src={props.dataItem.error ? failImg : successImg}
                                            />
                                        </span>
                                    </Tooltip>}
                                </td>
                            )}
                            width={'70'}
                        />
                        <GridColumn
                            field={'message'}
                            title="Message"
                            filterable={false}
                            headerClassName={classesGrid.gridColumnHeader}
                            className={classesGrid.fileNameDocumentGridViewDocuments}
                            width={'300'}
                        />
                        <GridColumn
                            field="fileNameDocumentSend"
                            title="Filename Document Send"
                            cell={(props) => (
                                <CellWithButton
                                    {...props}
                                    data={props.dataItem}
                                    action={'downloadSend'}
                                    handleDownloadDocument={handleDownloadDocument}
                                />
                            )}
                            headerClassName={classesGrid.gridColumnHeader}
                            width={'400'}
                        />
                        <GridColumn
                            field="fileNameDocumentResponse"
                            title="Filename Document Response"
                            cell={(props) => (
                                <CellWithButton
                                    {...props}
                                    data={props.dataItem}
                                    action={'downloadResponse'}
                                    handleDownloadDocument={handleDownloadDocument}
                                />
                            )}
                            headerClassName={classesGrid.gridColumnHeader}
                            width={'450'}
                        />
                    </Grid>
                </Dialog>
            )}
        </div>
    );
};
export default RelaticsDocumentsDialog;
